const CIAM_PREFIX = 'ciam_';

export const CIAM_LOCAL_STORAGE_KEYS = {
  COOKIE_ID: `${CIAM_PREFIX}cookie_id`,
} as const;

export type CIAMLocalStorageKeys =
  (typeof CIAM_LOCAL_STORAGE_KEYS)[keyof typeof CIAM_LOCAL_STORAGE_KEYS];

export function setLocalStorageValue(key: CIAMLocalStorageKeys, value: string): void {
  localStorage.setItem(key, value);
}

export function getLocalStorageValue(key: CIAMLocalStorageKeys): string | null {
  return localStorage.getItem(key);
}
